import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { forkJoin, from, of, Subscription } from 'rxjs';
import { AlertService } from 'src/app/components/_alert/alert.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SolicitudCreditoServiceWorkflow } from '../../../../shared/services/solicitud-credito-workflow.service';
import { catchError, filter, map, mergeMap, toArray } from 'rxjs/operators';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
//import { RutValidator } from 'ng9-rut';
import { rutValidate } from 'rut-helpers';
import { ModalBasicoConsolidadoService } from '../../../../shared/services/modal-basico-consolidado.service';
import { ESystemAccess } from 'src/app/enum/EAccess';
import { SessionService } from 'src/app/shared/services/session.service';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { ListDatesComponent } from '../../../list-dates/list-dates.component';
//import { SimpleModalService } from 'ngx-simple-modal';
import { MatDialog } from '@angular/material/dialog';
import { gtpRutValidator } from 'src/app/shared/validators/rut-validator';


interface CargaFinanciera {
  fechaCurse: string,
  institucion: string,
  tipoCredito: string,
  creditoOriginal: number | string,
  deudaActual: number | string,
  cuota: number | string,
  nCuotasPorPagar: number | string,
  nCuotasMorosas: number | string,
  ultimoVencimiento: string,
  garantiasVigentes: string
}

@Component({
  selector: 'app-plantilla-capex-modelo1',
  templateUrl: './plantilla-capex-modelo1.component.html',
  styleUrls: [
    './plantilla-capex-modelo1.component.scss',
    '../../styles/firefox-print-patch.scss'
  ]
})
export class PlantillaCapexModelo1 implements OnInit {
  //Informacion para plantilla no editable
  @Input() plantillaNoEditable: boolean = false;
  @Input() objEntradaFicha: any = {};
  @Input() objEntradaMotor: any = {};

  @Output() operacionNuevo = new EventEmitter<boolean>();
  @Output() finalizarFlujo = new EventEmitter<void>();
  @Output() bloqueaPasos5 = new EventEmitter<boolean>();
  @Output() bloqueaPasos6 = new EventEmitter<boolean>();
  @Input() idTransaccion: string = '';
  @Input() stepper!: number;
  @Input() rut: string = '';
  @Input() closed: boolean = true;
  public objectKeys = Object.keys;
  public servicioFichaForm!: FormGroup;
  public servicioDeudoresForm!: FormGroup;

  private access: string[] = [
    ESystemAccess.FLUJO_CREDITO_BUSCAR, 
    ESystemAccess.FLUJO_CREDITO_BUSCAR_ADMIN,
    ESystemAccess.FLUJO_CREDITO,
    ESystemAccess.FLUJO_CREDITO_ADMIN
  ];

  public activateRutComiteHelper: boolean = false;
  public activateRutClienteComiteHelper: boolean = false;

  public subscriptions: Subscription[] = [];
  public data: any;
  public today = '';
  public dataFiltrada: any;
  public dataCargada: boolean = false;
  public groupNameConsulting: string[] = ['buscarReportePrincipal', 'buscarReportesDerivados'];
  public groupNameConsultingFicha: string[] = ['buscarFichaDeCredito', 'buscarReportesDerivados', 'buscarReportePrincipal'];
  public groupNameConsultingScore: string[] = ['buscarCalculoScore', 'buscarReportesDerivados', 'buscarReportePrincipal'];
  public groupNameConsultingAprobacion: string[] = ['buscarReportesDerivados', 'buscarReportePrincipal'];
  public contratoServicios: any[] = [];
  public atributos: any[] = [];
  public reportesPrincipalesObj: any = {};
  public reportesDerivadosObj: any = {};
  public reportesDerivados: any = {};
  public entidadesDerivadas: any = {};
  public errores: any[] = [];
  public bodyModelos: any = {};
  public fichaGuardada: any = {}; // es para validar la existencia de una ficha guardada y habilitar el boton continuar
  public fichaComiteCredito: any = {};
  public cabeceraDeudores: any = {};
  public totalesInformacionFinanciera: any = {};
  public informacionFinancieraCabecera: any = {};
  public informacionFinancieraTable: any[] = [];
  public ventaPromMensual: any = null;
  public deudores: any[] = [];
  public sociosComposicion: any[] = [];
  public sociosInformes: any[] = [];
  public empresasRelacionadasComposicion: any[] = [];
  public empresasRelacionadasInformes: any[] = [];
  public showReportes: boolean = false;
  public showArchivos: boolean = false;
  public consolidadoTitular: any = {};
  public plantillaAntecedentes = 'cesceDemo';
  public modalDefault = true;
  public observaciones: any = {
    text: ''
  };
  public servicioFichaFormSaved: any = {};
  public servicioDeudoresFormSaved: any = {};
  public cargaFinanciera: CargaFinanciera[] = [];
  public nombreClienteCargaFinanciera: string = '';

  public reportesSeleccionado: any = {};
  public rutSeleccionado: string = '';
  public informeComercial: string = '';
  public totalesCargaFinanciera: any = {
    creditoOriginal: 0,
    deudaActual: 0,
    cuota: 0,
    nCuotasPorPagar: 0,
    nCuotasMorosas: 0,
  }
  public factoring: any[] = [];
  public lineaOperacionPropuesta: any = {};
  public lineaOperacionPropuestaTotales: any = {};
  public motorCalculos: any;
  public motorConDatos: boolean = false;
  public balanceManual: any[] = [];
  public dataManualCargada: boolean = false;
  public tablasCompraVenta: any = {};

  public listaReportesPrincipales: any[] = [];
  public listaReportesDerivados: any = {};

  public top10Clientes: any[] = [];
  public fechasCompraVenta: any[] = [];

  public formatos: any = {
    // deudoress
    porcentaje: 'decimal',
    facturaFinanciar: 'decimal',
    cheques: 'decimal',
    histCancelado: 'decimal',
    diasPromedio: 'decimal',
    fs: 'si-no',
    web: 'text',
    direccion: 'text',
    // carga financiera
    fechaCurse: 'text',
    institucion: 'text',
    tipoCredito: 'text',
    ultimoVencimiento: 'text',
    garantiasVigentes: 'text',
    creditoOriginal: 'decimal',
    deudaActual: 'decimal',
    cuota: 'decimal',
    nCuotasPorPagar: 'numero',
    nCuotasMorosas: 'numero',
  }

  public formatosLinea: any = {
    // linea / operacion propuesta
    lineaVigentefacturas: 'decimal',
    lineaPropuestafacturas: 'decimal',
    opPuntualVigentefacturas: 'decimal',
    opPuntualPropuestafacturas: 'decimal',

    lineaVigentefache: 'decimal',
    lineaPropuestafache: 'decimal',
    opPuntualVigentefache: 'decimal',
    opPuntualPropuestafache: 'decimal',

    lineaVigentecheques: 'decimal',
    lineaPropuestacheques: 'decimal',
    opPuntualVigentecheques: 'decimal',
    opPuntualPropuestacheques: 'decimal',

    lineaVigenteconfirming: 'decimal',
    lineaPropuestaconfirming: 'decimal',
    opPuntualVigenteconfirming: 'decimal',
    opPuntualPropuestaconfirming: 'decimal',

    lineaVigenteoc: 'decimal',
    lineaPropuestaoc: 'decimal',
    opPuntualVigenteoc: 'decimal',
    opPuntualPropuestaoc: 'decimal',

    lineaVigentecreditoDirecto: 'decimal',
    lineaPropuestacreditoDirecto: 'decimal',
    opPuntualVigentecreditoDirecto: 'decimal',
    opPuntualPropuestacreditoDirecto: 'decimal',

    vigentefacturas: 'decimal',
    propuestafacturas: 'decimal',
    canceladafacturas: 'decimal',

    vigentefache: 'decimal',
    propuestafache: 'decimal',
    canceladafache: 'decimal',

    vigentecheques: 'decimal',
    propuestacheques: 'decimal',
    canceladacheques: 'decimal',

    vigenteconfirming: 'decimal',
    propuestaconfirming: 'decimal',
    canceladaconfirming: 'decimal',

    vigenteoc: 'decimal',
    propuestaoc: 'decimal',
    canceladaoc: 'decimal',

    vigentecreditoDirecto: 'decimal',
    propuestacreditoDirecto: 'decimal',
    canceladacreditoDirecto: 'decimal',

    porcentajefacturas: 'decimal',
    porcentajefache: 'decimal',
    porcentajecheques: 'decimal',
    porcentajeconfirming: 'decimal',
    porcentajeoc: 'decimal',
    porcentajecreditoDirecto: 'decimal',

    plazoDiasfacturas: 'numero',
    plazoDiasfache: 'numero',
    plazoDiascheques: 'numero',
    plazoDiasconfirming: 'numero',
    plazoDiasoc: 'numero',
    plazoDiascreditoDirecto: 'numero',

    totalesLineaVigente: 'decimal',
    totalesLineaPropuesta: 'decimal',
    totalesOpPuntualVigente: 'decimal',
    totalesOpPuntualPropuesta: 'decimal',
    totalesPorcentaje: 'decimal',
    totalesPlazoDias: 'decimal',
    totalesVigente: 'decimal',
    totalesPropuesta: 'decimal',
    totalesCancelada: 'decimal',

    vencimiento: 'text',
    opPuntualM: 'decimal',
    riesgoTotalM: 'decimal',
    totalLineaM: 'decimal',
    presentacionCliente: 'text'
  }

  constructor(
    //private rutValidator: RutValidator,
    public alertService: AlertService,
    private solicitudCreditoService: SolicitudCreditoServiceWorkflow,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private modalService: ModalBasicoConsolidadoService,
    private _sessionService: SessionService,
    private utilsService: UtilsService,
    //private simpleModalService: SimpleModalService
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.operacionNuevo.emit(false);
    this.setToday();
    this.initForm();
    if(this.plantillaNoEditable === false){
      this.obtenerFlujo();
    } else {
      this.mapeoNoEditable();
      this.showArchivos = true;
    }
    this.onChanges();
  }

  redireccionPasoAnterior(ultimoPasoCompletado: number): void {
    let step = this.solicitudCreditoService.stepsOptions.filter((e: any) => e.stageID == (ultimoPasoCompletado + 1));
    if (!step[0]?.step){
      step = this.solicitudCreditoService.stepsOptions.filter((e: any) => e.stageID == (ultimoPasoCompletado));
    }
    this.alertService.error(`Solicitud de Crédito - Debe completar el paso N° ${Number(step[0]?.step)} para poder continuar`);
    this.solicitudCreditoService.setStep(Number(step[0]?.step));
  }

  mapeoNoEditable(): void {
    this.callServicesFichaAprobacion();    
  }

  // Logica de revision de paso y llamada a servicios

  obtenerFlujo(): void{
    this.spinner.show();
    this.subscriptions.push(this.solicitudCreditoService.obtenerFlujo(this.idTransaccion, this.rut).subscribe(resp => {
      this.bodyModelos = resp;
      let paso: any;
      let pasoAnterior: any;
      const pasosCompleted = resp.stages.filter((e: any) => e.completed);
      const cantidad = pasosCompleted.length;
      const ultimoPasoCompletado = Number(pasosCompleted[cantidad - 1].stageID);
      this.closed = (resp.closed === null || resp.closed === undefined) ? true : resp.closed;
      this.showArchivos = true;

      if(this.stepper === 5){
        resp.stages.forEach((e: any) => {
          if(e.stageID === '10'){
            paso = e;
          }
        });
        // Se valida si el paso anterior fue completado y si no se envia al ultimo completado
        if(paso?.stageID === '10' && (paso?.completed === false && paso?.optional === false)){ //pasoAnterior && !pasoAnterior?.completed
          let pasoAnteriorCompleted = ultimoPasoCompletado;
          if(ultimoPasoCompletado === 9)
            pasoAnteriorCompleted = 8;

          this.redireccionPasoAnterior(pasoAnteriorCompleted);
        } else {
          if (paso?.stageID === '10' && paso?.completed === true) { // Se realizo el calculo del score
            this.callServicesFichaScore();
          } else {
            this.redireccionPasoAnterior(ultimoPasoCompletado);
          }
        }
      } else {
        resp.stages.forEach((e: any) => {
          if(e.stageID === '9'){
            paso = e;
          } else if (e.stageID === '8'){
            pasoAnterior = e;
          }
        });
        // Se valida si el paso anterior fue completado y si no se envia al ultimo completado
        if(pasoAnterior && (!pasoAnterior?.completed && pasoAnterior?.optional === false)){
          this.redireccionPasoAnterior(ultimoPasoCompletado);
        } else {
          if (paso?.stageID === '9' && paso?.completed === false) { // primera vez en esta pantalla -> cambiar para pruebas
            this.callServices();
          }
          else if(paso?.stageID === '9' && paso?.completed === true){ // ya se habia llegado antes a esta pantalla -> cambiar para pruebas
            this.callServicesFicha();
          }
        }
      }
    }, (error: any) => {
      this.alertService.error(error?.error?.message || 'Solicitud de Crédito - Ocurrio un error al recuperar los datos del flujo de credito');
      this.spinner.hide();
    }));

  }

  // Llamada a servicios para obtener ficha con score guardada

  async callServicesFichaAprobacion(): Promise<void> {
    const apiServices: any = [];

    if (this.groupNameConsultingAprobacion.length > 0) {
      for await (const value of this.groupNameConsultingAprobacion) {
        apiServices.push(this.getServices(value))
      }
    }

    this.spinner.show();
    this.subscriptions.push(forkJoin(apiServices).subscribe((resp) => {
      this.spinner.hide();
      if (this.errores.length > 0){
        this.errores.forEach((element: any) => {
          this.alertService.error(element.msg);
        });
        this.spinner.hide();
      } else {
        this.buscarReportes("callServicesFichaAprobacion");
      }
    },
      (error) => {
        this.alertService.error(error?.message);
        this.spinner.hide();
      }
    ));
  }

  // Llamada a servicios para obtener ficha con score guardada

  async callServicesFichaScore(): Promise<void> {
    const apiServices: any = [];

    if (this.groupNameConsultingScore.length > 0) {
      for await (const value of this.groupNameConsultingScore) {
        apiServices.push(this.getServices(value))
      }
    }

    this.spinner.show();
    this.subscriptions.push(forkJoin(apiServices).subscribe((resp) => {
      this.spinner.hide();
      if (this.errores.length > 0){
        this.errores.forEach((element: any) => {
          this.alertService.error(element.msg);
        });
        this.spinner.hide();
      } else {
        this.buscarReportes("callServicesFichaScore");
      }
    },
      (error) => {
        this.alertService.error(error?.message);
        this.spinner.hide();
      }
    ));
  }

  // Llamada a servicios para obtener ficha guardada

  async callServicesFicha(): Promise<void> {
    const apiServices: any = [];

    if (this.groupNameConsulting.length > 0) {
      for await (const value of this.groupNameConsultingFicha) {
        apiServices.push(this.getServices(value))
      }
    }

    this.spinner.show();
    this.subscriptions.push(forkJoin(apiServices).subscribe((resp) => {
      this.spinner.hide();
      if (this.errores.length > 0){
        this.errores.forEach((element: any) => {
          this.alertService.error(element.msg);
        });
        this.spinner.hide();
      } else {
        this.buscarReportes("callServicesFicha");
      }
    },
      (error) => {
        this.alertService.error(error?.message);
        this.spinner.hide();
      }
    ));
  }

  obtenerBalanceAutomatico(): void {
    const datos = this.utilsService.obtenerDatosF22(this.reportesPrincipalesObj, true, true, true, false, true);

    if(datos.length > 0){
      this.data = this.utilsService.calculosVariacion(datos);
      let periodos = this.utilsService.obtenerPeriodos(this.data);
      periodos = periodos.slice(0, 2);
      this.dataFiltrada = this.utilsService.obtenerReporteFiltrado(this.data, periodos);
      this.dataCargada = true;
    } else {
      this.dataCargada = false;
    }
  }

  // Mapeo de error en consultas asincronas

  setError(reporte: string, error: string): void {
    this.errores.push({
      id: reporte,
      msg: error
    })
  }

  // Mapeo de respuestas correctas en consultas asincronas

  setResponse(service: string, response: any): void {
    if (service === 'buscarReportePrincipal'){
      this.contratoServicios = response?.Stage3Response?.ContratoServicios || [];
      this.atributos = response?.Stage2Response?.Atributos || [];
      this.listaReportesPrincipales = response?.ReportKeys || [];
    }
    else if (service === 'buscarReportesDerivados'){

      this.listaReportesDerivados = response?.ReportKeys || {};
      this.entidadesDerivadas = response?.Stage5Response?.Entidades;
      
    } else if (service === 'buscarFichaDeCredito'){
      this.fichaGuardada = response?.FichaDeCredito;
      const ficha = response?.FichaDeCredito?.ficha;
      this.servicioFichaFormSaved = ficha?.servicioFichaForm;
      this.servicioDeudoresFormSaved = ficha?.servicioDeudoresForm;
      this.sociosComposicion = ficha?.sociosComposicion || [];
      this.empresasRelacionadasComposicion = ficha?.empresasRelacionadasComposicion || [];
      this.sociosInformes = ficha?.sociosInformes || [];
      this.empresasRelacionadasInformes = ficha?.empresasRelacionadasInformes || [];
      this.deudores = ficha?.deudores || [];
      this.informacionFinancieraCabecera = ficha?.informacionFinancieraCabecera || {};
      this.totalesInformacionFinanciera = ficha?.totalesInformacionFinanciera || {};
      this.ventaPromMensual = ficha?.ventaPromMensual || null;
      this.informacionFinancieraTable = ficha?.informacionFinancieraTable || [];
      this.dataFiltrada = ficha?.dataFiltrada || {};
      this.rut = ficha?.rut || '';
      this.consolidadoTitular = ficha?.consolidadoTitular || {};
      this.observaciones = ficha?.observaciones || {
        text: ''
      };
      this.totalesCargaFinanciera = ficha?.totalesCargaFinanciera || {
        creditoOriginal: 0,
        deudaActual: 0,
        cuota: 0,
        nCuotasPorPagar: 0,
        nCuotasMorosas: 0,
      };
      this.cargaFinanciera = ficha?.cargaFinanciera || [];
      this.tablasCompraVenta = ficha?.tablasCompraVenta || {};
      this.nombreClienteCargaFinanciera = ficha?.nombreClienteCargaFinanciera || '';
      this.factoring = ficha?.factoring || [];
      this.lineaOperacionPropuesta = ficha?.lineaOperacionPropuesta || {};
      this.lineaOperacionPropuestaTotales = ficha?.lineaOperacionPropuestaTotales || {};
      this.top10Clientes = ficha?.top10Clientes || [];
      this.fechasCompraVenta = ficha?.fechasCompraVenta || [];

      this.balanceManual = ficha?.balanceManual || [];
      (this.balanceManual.length > 0) ? this.dataManualCargada = true : this.dataManualCargada = false;

    } else if (service === 'buscarCalculoScore'){
      this.fichaGuardada = response?.FichaDeCredito;
      const ficha = response?.FichaDeCredito?.ficha;
      this.servicioFichaFormSaved = ficha?.servicioFichaForm;
      this.servicioDeudoresFormSaved = ficha?.servicioDeudoresForm;
      this.sociosComposicion = ficha?.sociosComposicion || [];
      this.empresasRelacionadasComposicion = ficha?.empresasRelacionadasComposicion || [];
      this.sociosInformes = ficha?.sociosInformes || [];
      this.empresasRelacionadasInformes = ficha?.empresasRelacionadasInformes || [];
      this.deudores = ficha?.deudores || [];
      this.informacionFinancieraCabecera = ficha?.informacionFinancieraCabecera || {};
      this.totalesInformacionFinanciera = ficha?.totalesInformacionFinanciera || {};
      this.ventaPromMensual = ficha?.ventaPromMensual || null;
      this.informacionFinancieraTable = ficha?.informacionFinancieraTable || [];
      this.dataFiltrada = ficha?.dataFiltrada || {};
      this.rut = ficha?.rut || '';
      this.consolidadoTitular = ficha?.consolidadoTitular || {};
      this.observaciones = ficha?.observaciones || {
        text: ''
      };
      this.totalesCargaFinanciera = ficha?.totalesCargaFinanciera || {
        creditoOriginal: 0,
        deudaActual: 0,
        cuota: 0,
        nCuotasPorPagar: 0,
        nCuotasMorosas: 0,
      };
      this.cargaFinanciera = ficha?.cargaFinanciera || [];
      this.tablasCompraVenta = ficha?.tablasCompraVenta || {};
      this.nombreClienteCargaFinanciera = ficha?.nombreClienteCargaFinanciera || '';
      this.factoring = ficha?.factoring || [];
      this.lineaOperacionPropuesta = ficha?.lineaOperacionPropuesta || {};
      this.lineaOperacionPropuestaTotales = ficha?.lineaOperacionPropuestaTotales || {};
      this.balanceManual = ficha?.balanceManual || [];
      this.top10Clientes = ficha?.top10Clientes || [];
      this.fechasCompraVenta = ficha?.fechasCompraVenta || [];

      this.motorCalculos = response?.MotorDeCalculos;

      if(this.motorCalculos?.ResponseReglas?.message){
        this.motorConDatos = false;
      } else {
        this.motorConDatos = true;
      }

      (this.balanceManual.length > 0) ? this.dataManualCargada = true : this.dataManualCargada = false;
      (ficha && Object.keys(ficha).length > 0) ? this.showReportes = true : this.showReportes = false;
      (this.dataFiltrada && Object.keys(this.dataFiltrada).length > 0) ? this.dataCargada = true : this.dataCargada = false;
    }
  }

  //Definicion llamada a servicios asincronos por primera vez en la vista

  getServices(service: string): any {
    const objeto: any = {
      'buscarReportePrincipal': () => {
        return this.solicitudCreditoService.buscarReportePrincipal(this.idTransaccion, this.rut)
          .pipe(
            map(resp => {
              this.setResponse(service, resp);
            })
          )
          .pipe(
            catchError((error) => (this.setError(service, error?.error?.message || 'Solicitud de Crédito - Error Inesperado en servicio de reportes principales'), of(null))));
      },
      'buscarReportesDerivados': () => {
        return this.solicitudCreditoService.buscarReportesDerivados(this.idTransaccion, this.rut)
        .pipe(
          map(resp => {
            this.setResponse(service, resp);
          })
        )
        .pipe(
          catchError((error) => (this.setError(service, error?.error?.message || 'Solicitud de Crédito - Error Inesperado en servicio de reportes derivados'), of(null))));
      },
      'buscarFichaDeCredito': () => {
        return this.solicitudCreditoService.buscarFichaDeCredito(this.idTransaccion, this.rut)
        .pipe(
          map(resp => {
            this.setResponse(service, resp);
          })
        )
        .pipe(
          catchError((error) => (this.setError(service, error?.error?.message || 'Solicitud de Crédito - Error Inesperado en servicio de carga de ficha'), of(null))));
      },
      'buscarCalculoScore': () => {
        return this.solicitudCreditoService.buscarCalculoScore(this.rut, this.idTransaccion)
        .pipe(
          map(resp => {
            this.setResponse(service, resp);
          })
        )
        .pipe(
          catchError((error) => (this.setError(service, error?.error?.message || 'Solicitud de Crédito - Error Inesperado en servicio de carga de ficha con Score'), of(null))));
      }
    };
    return objeto[service]();
  }

  // Llamada a servicios asincronos por primera vez en la vista

  async callServices(): Promise<void> {
    const apiServices: any = [];

    if (this.groupNameConsulting.length > 0) {
      for await (const value of this.groupNameConsulting) {
        apiServices.push(this.getServices(value))
      }
    }

    this.spinner.show();
    this.subscriptions.push(forkJoin(apiServices).subscribe((resp) => {
      this.spinner.hide();
      if (this.errores.length > 0){
        this.errores.forEach((element: any) => {
          this.alertService.error(element.msg);
        });
        this.spinner.hide();
      } else {
        this.buscarReportes("callServices");
      }
    },
      (error) => {
        this.alertService.error(error.message);
        this.spinner.hide();
      }
    ));
  }

  buscarReportes(etapa: string): void {
    const apiServicesReportes: any = this.utilsService.obtenerServicesReportes(this.listaReportesPrincipales, this.listaReportesDerivados) || [];
    let count = 0;

    this.spinner.show();
    from(apiServicesReportes).pipe( 
      mergeMap(
        (service: any) => 
          this.solicitudCreditoService.buscarReportes(
            this.idTransaccion, 
            this.rut, 
            service.principal, 
            service.reportKey, 
            service.entidad, 
            service.rutDerivado
          )
          .pipe(
            catchError(error => {
              //console.error(`Error en la consulta del servicio: ${service.principal}, ${service.reportKey}, ${service.entidad}, ${service.rutDerivado}`);
              return of(null); // Retorna un observable que emite un valor nulo
            }),
            map(response => {
              if (response !== null) {
                count++;
              }
              return {
                service: service,
                response: response
              };
            }),
          ),
          20
        ), 
        filter(response => response !== null),
      toArray()
    ).subscribe(responses => {
      if (count === 0) { // Si no hubo respuestas válidas
        this.alertService.error('Solicitud de Crédito - Ha ocurrido un error al consultar la información de todos los reportes');
        this.spinner.hide();
      } else if (count < apiServicesReportes.length) { // Si hubo respuestas válidas pero no para todos los servicios
        this.alertService.error('Solicitud de Crédito - Ha ocurrido un error al consultar la información de algunos de los reportes');
      }
      if(count > 0){
        this.reportesPrincipalesObj = this.utilsService.mapeoReportesPrincipales(responses);
        this.reportesDerivadosObj = this.utilsService.mapeoReportesDerivados(responses);
        if (etapa === 'callServices'){
          this.obtenerBalanceAutomatico();
          this.informeComercial = this.utilsService.identificarInformeComercial(this.reportesSeleccionado?.basicReport?.reporte);
          this.mapeoReportes();
          this.initForm();
          this.spinner.hide();
        } else if (etapa === 'callServicesFicha'){
          this.initForm();
          this.showReportes = true;
          this.dataFiltrada && Object.keys(this.dataFiltrada).length > 0 ? this.dataCargada = true : this.dataCargada = false;
          this.spinner.hide();
        } else if (etapa === 'callServicesFichaAprobacion'){
          this.initForm();
          this.mapeoFichaGuardada();
          this.spinner.hide();
        } else {
          this.initForm();
          this.spinner.hide();
        }
      }
    }, error => {
      if (count > 0) {
        this.alertService.error('Solicitud de Crédito - Ha ocurrido un error al consultar la información de algunos de los reportes');
      } else {
        this.alertService.error('Solicitud de Crédito - Ha ocurrido un error al consultar la información de todos los reportes');
        this.spinner.hide();
      }
    });
  }

  mapeoFichaGuardada(): void {
    this.fichaGuardada = this.objEntradaFicha;
    const ficha = this.objEntradaFicha?.ficha;
    this.servicioFichaFormSaved = ficha?.servicioFichaForm;
    this.servicioDeudoresFormSaved = ficha?.servicioDeudoresForm;
    this.sociosComposicion = ficha?.sociosComposicion || [];
    this.empresasRelacionadasComposicion = ficha?.empresasRelacionadasComposicion || [];
    this.sociosInformes = ficha?.sociosInformes || [];
    this.empresasRelacionadasInformes = ficha?.empresasRelacionadasInformes || [];
    this.deudores = ficha?.deudores || [];
    this.informacionFinancieraCabecera = ficha?.informacionFinancieraCabecera || {};
    this.totalesInformacionFinanciera = ficha?.totalesInformacionFinanciera || {};
    this.ventaPromMensual = ficha?.ventaPromMensual || null;
    this.informacionFinancieraTable = ficha?.informacionFinancieraTable || [];
    this.dataFiltrada = ficha?.dataFiltrada || {};
    this.rut = ficha?.rut || '';
    this.observaciones = ficha?.observaciones || {
      text: ''
    };
    this.totalesCargaFinanciera = ficha?.totalesCargaFinanciera || {
      creditoOriginal: 0,
      deudaActual: 0,
      cuota: 0,
      nCuotasPorPagar: 0,
      nCuotasMorosas: 0,
    };
    this.cargaFinanciera = ficha?.cargaFinanciera || [];
    this.tablasCompraVenta = ficha?.tablasCompraVenta || {};
    this.nombreClienteCargaFinanciera = ficha?.nombreClienteCargaFinanciera || '';
    this.factoring = ficha?.factoring || [];
    this.lineaOperacionPropuesta = ficha?.lineaOperacionPropuesta || {};
    this.lineaOperacionPropuestaTotales = ficha?.lineaOperacionPropuestaTotales || {};
    this.balanceManual = ficha?.balanceManual || [];
    this.consolidadoTitular = ficha?.consolidadoTitular || {};
    this.top10Clientes = ficha?.top10Clientes || [];
    this.fechasCompraVenta = ficha?.fechasCompraVenta || [];

    this.motorCalculos = this.objEntradaMotor;
    if(this.motorCalculos?.ResponseReglas?.message){
      this.motorConDatos = false;
    } else {
      this.motorConDatos = true;
    }

    (this.balanceManual.length > 0) ? this.dataManualCargada = true : this.dataManualCargada = false;
    (ficha && Object.keys(ficha).length > 0) ? this.showReportes = true : this.showReportes = false;
    (this.dataFiltrada && Object.keys(this.dataFiltrada).length > 0) ? this.dataCargada = true : this.dataCargada = false;
    this.initForm();
  }

  // Objeto de cabecera de la ficha y deudores

  crearFichaComiteCredito(today: string, fechaInicio: string): void {
    const atributos = this.atributos || [];
    let [ejecutivo, canal, sucursal] = '';
    atributos.forEach((element: any) => {
      if(element?.nameAttribute.toUpperCase() === 'SUCURSAL' && !isNaN(Number(element?.value))){
        sucursal = element?.allowedValues[Number(element?.value)] || '';
      }
      if(element?.nameAttribute.toUpperCase() === 'EJECUTIVO' ){
        ejecutivo = element?.allowedValues[Number(element?.value)] || '';
      }
      if(element?.nameAttribute.toUpperCase() === 'CANAL ADMISION' ){
        canal = element?.allowedValues[Number(element?.value)] || '';
      }
    });
    this.fichaComiteCredito = {
      nombre: this.reportesPrincipalesObj?.basicReport?.reporte?.InformacionBasica?.NombreORazonSocial || '',
      fecha: today, // fecha de hoy
      giro: this.reportesPrincipalesObj?.basicReport?.reporte?.Riesgo?.ActividadEconomica || '',
      ejecutivo: ejecutivo, // Stage 2
      rut: this.reportesPrincipalesObj?.basicReport?.reporte?.InformacionBasica?.Rut || '',
      canal: canal, // Stage 2
      sucursal: sucursal, // Stage 2
      pagina: '', // dato manual
      enrolado: this.utilsService.obtenerEnrolado(this.contratoServicios), // libro compra venta
      fechaInicio: this.reportesPrincipalesObj?.basicReport?.reporte?.InformacionBasica?.AnoInicioActividades? fechaInicio : ''
    }

    this.cabeceraDeudores = {
      nombre: this.reportesPrincipalesObj?.basicReport?.reporte?.InformacionBasica?.NombreORazonSocial || '',
      rut: this.reportesPrincipalesObj?.basicReport?.reporte?.InformacionBasica?.Rut || '',
      fecha: today,
    }
  }

  // Crea los objetos para la seccion de Linea / Operacion Propuesta

  crearLineaOperacionPropuesta(): void{
    this.lineaOperacionPropuesta = {
      producto:[{
          id: 'facturas',
          texto: 'Facturas'
        },
        {
          id: 'fache',
          texto: 'Fache'
        },
        {
          id: 'cheques',
          texto: 'Cheques'
        },
        {
          id: 'confirming',
          texto: 'Confirming'
        },
        {
          id: 'oc',
          texto: 'OC'
        },
        {
          id: 'creditoDirecto',
          texto: 'Credito Directo'
        },
        {
          id: 'prontoPago',
          texto: 'Pronto Pago'
        },
      ],
      lineaVigente: {
        facturas: 0,
        fache: 0,
        cheques: 0,
        confirming: 0,
        oc: 0,
        creditoDirecto: 0,
        prontoPago: 0,
      },
      lineaPropuesta: {
        facturas: 0,
        fache: 0,
        cheques: 0,
        confirming: 0,
        oc: 0,
        creditoDirecto: 0,
        prontoPago: 0,
      },
      opPuntualVigente: {
        facturas: 0,
        fache: 0,
        cheques: 0,
        confirming: 0,
        oc: 0,
        creditoDirecto: 0,
        prontoPago: 0,
      },
      opPuntualPropuesta: {
        facturas: 0,
        fache: 0,
        cheques: 0,
        confirming: 0,
        oc: 0,
        creditoDirecto: 0,
        prontoPago: 0,
      },
      porcentaje: {
        facturas: 0,
        fache: 0,
        cheques: 0,
        confirming: 0,
        oc: 0,
        creditoDirecto: 0,
        prontoPago: 0,
      },
      plazoDias: {
        facturas: 0,
        fache: 0,
        cheques: 0,
        confirming: 0,
        oc: 0,
        creditoDirecto: 0,
        prontoPago: 0,
      },
      vigente: {
        facturas: 0,
        fache: 0,
        cheques: 0,
        confirming: 0,
        oc: 0,
        creditoDirecto: 0,
        prontoPago: 0,
      },
      propuesta: {
        facturas: 0,
        fache: 0,
        cheques: 0,
        confirming: 0,
        oc: 0,
        creditoDirecto: 0,
        prontoPago: 0,
      },
      cancelada: {
        facturas: 0,
        fache: 0,
        cheques: 0,
        confirming: 0,
        oc: 0,
        creditoDirecto: 0,
        prontoPago: 0,
      },
      vencimiento: '',
      opPuntualM: 0,
      riesgoTotalM: 0,
      totalLineaM: 0,
      presentacionCliente: ''
    };

    this.lineaOperacionPropuestaTotales = {
      totalesLineaVigente: 0,
      totalesLineaPropuesta: 0,
      totalesOpPuntualVigente: 0,
      totalesOpPuntualPropuesta: 0,
      totalesPorcentaje: 0,
      totalesPlazoDias: 0,
      totalesVigente: 0,
      totalesPropuesta: 0,
      totalesCancelada: 0,
    }
  }

  // Mapeo y generacion de objetos para tablas

  mapeoReportes(): void {
    const date = new Date();

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    let today = '';
    
    if(month < 10){
      today = day < 10 ? `0${day}-0${month}-${year}` : `${day}-0${month}-${year}`;
    }else{
      today = day < 10 ? `0${day}-${month}-${year}` : `${day}-${month}-${year}`;
    }

    const dateInicio = new Date(this.reportesPrincipalesObj?.basicReport?.reporte?.InformacionBasica?.AnoInicioActividades);
    const fechaInicio = `${dateInicio.getDate() < 10? '0'+(dateInicio.getDate()) : dateInicio.getDate()}-${(dateInicio.getMonth() + 1 < 10?  '0'+(dateInicio.getMonth() + 1) : 
    dateInicio.getMonth() + 1)}-${dateInicio.getFullYear()}`;

    /* INICIO Logica de obtencion de datos de F22 y F29 */

    const F22Limpio = this.utilsService.obtenerDatosF22(this.reportesPrincipalesObj, true, true, true, false, true); // Funcion donde hace la logica
    const F29Limpio = this.utilsService.obtenerDatosF29(this.reportesPrincipalesObj, true, true, true);

    /* FIN Logica de obtencion de datos de F22 y F29 */

    let anioActual = new Date().getFullYear();
    let anioAnterior = 0;
    
    if(F22Limpio.length > 1){
      anioActual = Number(F22Limpio[0]?.calculado?.periodo);
      anioAnterior = Number(F22Limpio[1]?.calculado?.periodo);
    } else {
      if (F22Limpio.length > 0){
        anioActual = Number(F22Limpio[0]?.calculado?.periodo)
      }
      else {
        anioActual = new Date().getFullYear();
      }
      anioAnterior = anioActual - 1;
    }
    
    const anioActualVentas = new Date().getFullYear();
    const anioAnteriorVentas = Number(anioActualVentas - 1);

    const libroCV: any = this.utilsService.getLibrosMapeados(this.reportesPrincipalesObj?.libroCompraVenta?.reporte?.Libros || [], this.reportesPrincipalesObj?.libroCompraVentaObtenerReporte?.reporte?.Libros || []);

    this.crearFichaComiteCredito(today, fechaInicio); // crear cabecera ficha y de deudores
    const { totalesInformacionFinanciera, informacionFinancieraTable } = this.utilsService.crearInformacionFinancieraTableCapex(anioActualVentas, anioAnteriorVentas, F29Limpio, libroCV);
    this.totalesInformacionFinanciera = totalesInformacionFinanciera;
    this.informacionFinancieraTable = informacionFinancieraTable;

    this.ventaPromMensual = this.utilsService.calcularVentaPromedioMensual(libroCV);
    
    const f22ActualIndex = F22Limpio?.findIndex((elemento: any) => Number(elemento?.calculado?.periodo) === anioActual);
    let f22Actual: any = null;

    if(f22ActualIndex >= 0){
      f22Actual = F22Limpio[f22ActualIndex] || null;
    }

    this.informacionFinancieraCabecera = this.utilsService.crearInformacionFinancieraCabecera(anioActual, anioAnterior, anioActualVentas, anioAnteriorVentas, f22Actual, this.totalesInformacionFinanciera, this.reportesPrincipalesObj?.basicReport); // crear la cabecera de la tabla financiera
    const { entidadComposicion: sociosComposicion, entidadInformes: sociosInformes } = this.utilsService.crearSociosComposicionInforme('socios', this.entidadesDerivadas, this.reportesDerivadosObj); // crea las tablas composicion de sociedad para socios e informes comerciales para socios
    this.sociosComposicion = sociosComposicion;
    this.sociosInformes = sociosInformes;
    const { entidadComposicion: empresasComposicion, entidadInformes: empresasInformes } = this.utilsService.crearSociosComposicionInforme('empresasRelacionadas', this.entidadesDerivadas, this.reportesDerivadosObj); // crea las tablas composicion de sociedad para empresa e informes comerciales para empresa -> se debe cambiar socios por el que corresponda
    this.empresasRelacionadasComposicion = empresasComposicion;
    this.empresasRelacionadasInformes = empresasInformes;
    this.deudores = this.utilsService.crearDeudores('deudores', this.entidadesDerivadas, this.reportesDerivadosObj);
    this.deudores = this.incluirNcReclamos(this.deudores, this.reportesDerivadosObj);
    this.tablasCompraVenta = this.utilsService.crearCompraVentaFichaCapital(libroCV);
    const { cargaFinanciera, nombreClienteCargaFinanciera } = this.utilsService.crearCargaFinanciera(this.reportesPrincipalesObj?.basicReport);
    this.cargaFinanciera = cargaFinanciera;
    this.nombreClienteCargaFinanciera = nombreClienteCargaFinanciera;
    this.consolidadoTitular = this.utilsService.crearConsolidadoTitular(F22Limpio, F29Limpio, this.reportesPrincipalesObj);
    this.factoring = this.utilsService.crearFactoring(this.reportesPrincipalesObj?.cesionFacturas);
    this.crearLineaOperacionPropuesta();

    if(this.reportesPrincipalesObj?.f22Manual?.reporte?.Formulario22Reporte?.Reporte){
      this.balanceManual.push(this.reportesPrincipalesObj?.f22Manual?.reporte?.Formulario22Reporte?.Reporte);
      this.dataManualCargada = true;
    }

    const deudores = this.entidadesDerivadas.find((e: any) => e?.entidad === 'deudores');
    if(deudores){
      this.top10Clientes = this.utilsService.obtenerTop10Clientes(deudores.items || []);
      this.top10Clientes = this.utilsService.addRangoSiiTop10(this.top10Clientes, this.deudores);
    }

    this.fechasCompraVenta = this.utilsService.getFechasCompraVenta(libroCV);

    this.showReportes = true;
  }

  incluirNcReclamos(deudores: any[], reportesDerivados: any): any[] {
    if(deudores && deudores.length > 0){
      for(const deudor of deudores){
        if(deudor?.rut && reportesDerivados?.deudores?.[deudor?.rut]?.lcvData && Object.keys(reportesDerivados?.deudores?.[deudor?.rut]?.lcvData).length > 0){
          const lcvData = reportesDerivados?.deudores?.[deudor?.rut]?.lcvData;
          deudor.porcentajeNcSobreVentas = (lcvData?.porcentajeNcSobreVentas || lcvData?.porcentajeNcSobreVentas === 0) ? lcvData?.porcentajeNcSobreVentas : 0;
          deudor.procentajeReclamos = (lcvData?.procentajeReclamos || lcvData?.procentajeReclamos === 0) ? lcvData?.procentajeReclamos : 0;
        }
      }
    }
    return deudores;
  }

  showDetalleFechas():void {
    const dialogRef = this.dialog.open(ListDatesComponent, {
      data: {
        title: 'Periodos Reporte Libro Compra Venta',
       fechas: this.fechasCompraVenta
      }
    });

    dialogRef.afterClosed().subscribe(resp => {
      if (resp.confirm) {
        //this.submitArchivo();
      }
    });
    /*const resp = this.simpleModalService.addModal(ListDatesComponent, {
       title: 'Periodos Reporte Libro Compra Venta',
       fechas: this.fechasCompraVenta
     }).subscribe((resp) => {
       if (resp.confirm) {
         //this.submitArchivo();
       }
     });*/
   }

  // Logicas de Formulario y funciones

  // Se inicializa el formulario de los datos de las cabeceras con datos a ingresar

  initForm(): void {
    if(this.stepper === 5 || this.plantillaNoEditable === true){
      this.servicioFichaForm = this.formBuilder.group({
        nombreComite: [{value: this.servicioFichaFormSaved?.nombreComite || this.fichaComiteCredito?.nombre || '', disabled: true}, [Validators.required]],
        fechaComite: [{value: this.servicioFichaFormSaved?.fechaComite || this.fichaComiteCredito?.fecha || '', disabled: true}, [Validators.required]],
        giroComite: [{value: this.servicioFichaFormSaved?.giroComite || this.fichaComiteCredito?.giro || '', disabled: true}, [Validators.required]],
        ejecutivoComite: [{value: this.servicioFichaFormSaved?.ejecutivoComite || this.fichaComiteCredito?.ejecutivo || '', disabled: true}, [Validators.required]],
        rutComite: [{value: this.servicioFichaFormSaved?.rutComite || this.fichaComiteCredito?.rut, disabled: true}, [Validators.required, gtpRutValidator()]],
        canalAdmisionComite: [{value: this.servicioFichaFormSaved?.canalAdmisionComite || this.fichaComiteCredito?.canal || '', disabled: true}, [Validators.required]],
        sucursalComite: [{value: this.servicioFichaFormSaved?.sucursalComite || this.fichaComiteCredito?.sucursal || '', disabled: true}, [Validators.required]],
        paginaWebComite: [{value: this.servicioFichaFormSaved?.paginaWebComite || this.fichaComiteCredito?.pagina || '', disabled: true}, [Validators.required]],
        enroladoComite: [{value: this.servicioFichaFormSaved?.enroladoComite || this.fichaComiteCredito?.enrolado || '', disabled: true}, [Validators.required]],
        inicioSiiComite: [{value: this.servicioFichaFormSaved?.inicioSiiComite || this.fichaComiteCredito?.fechaInicio || '', disabled: true}, [Validators.required]]
      });
      
      this.servicioDeudoresForm = this.formBuilder.group({
        clienteComite: [{value: this.servicioDeudoresFormSaved?.clienteComite || this.cabeceraDeudores?.nombre || '', disabled: true}, [Validators.required]],
        rutClienteComite: [{value: this.servicioDeudoresFormSaved?.rutClienteComite || this.cabeceraDeudores?.rut || '', disabled: true}, [Validators.required, gtpRutValidator()]],
        fechaClienteComite: [{value: this.servicioDeudoresFormSaved?.fechaClienteComite || this.cabeceraDeudores?.fecha || '', disabled: true}, [Validators.required]],
      });

    } else {
      this.servicioFichaForm = this.formBuilder.group({
        nombreComite: [{value: this.servicioFichaFormSaved?.nombreComite || this.fichaComiteCredito?.nombre || '', disabled: true}, [Validators.required]],
        fechaComite: [{value: this.servicioFichaFormSaved?.fechaComite || this.fichaComiteCredito?.fecha || '', disabled: true}, [Validators.required]],
        giroComite: [{value: this.servicioFichaFormSaved?.giroComite || this.fichaComiteCredito?.giro || '', disabled: true}, [Validators.required]],
        ejecutivoComite: [{value: this.servicioFichaFormSaved?.ejecutivoComite || this.fichaComiteCredito?.ejecutivo || '', disabled: true}, [Validators.required]],
        rutComite: [{value: this.servicioFichaFormSaved?.rutComite || this.fichaComiteCredito?.rut, disabled: true}, [Validators.required, gtpRutValidator()]],
        canalAdmisionComite: [{value: this.servicioFichaFormSaved?.canalAdmisionComite || this.fichaComiteCredito?.canal || '', disabled: true}, [Validators.required]],
        sucursalComite: [{value: this.servicioFichaFormSaved?.sucursalComite || this.fichaComiteCredito?.sucursal || '', disabled: true}, [Validators.required]],
        paginaWebComite: [ this.servicioFichaFormSaved?.paginaWebComite || this.fichaComiteCredito?.pagina || '', [Validators.required]],
        enroladoComite: [{value: this.servicioFichaFormSaved?.enroladoComite || this.fichaComiteCredito?.enrolado || '', disabled: true}, [Validators.required]],
        inicioSiiComite: [{value: this.servicioFichaFormSaved?.inicioSiiComite || this.fichaComiteCredito?.fechaInicio || '', disabled: true}, [Validators.required]]
      });
      
      this.servicioDeudoresForm = this.formBuilder.group({
        clienteComite: [{value: this.servicioDeudoresFormSaved?.clienteComite || this.cabeceraDeudores?.nombre || '', disabled: true}, [Validators.required]],
        rutClienteComite: [{value: this.servicioDeudoresFormSaved?.rutClienteComite || this.cabeceraDeudores?.rut || '', disabled: true}, [Validators.required, gtpRutValidator()]],
        fechaClienteComite: [{value: this.servicioDeudoresFormSaved?.fechaClienteComite || this.cabeceraDeudores?.fecha || '', disabled: true}, [Validators.required]],
      });
    }
  }

  onChanges(): void {
    this.servicioFichaForm.valueChanges.subscribe(val => {
      this.activateRutComiteHelper = rutValidate(val.rutComite) ? false : true;
    });
    this.servicioDeudoresForm.valueChanges.subscribe(val => {
      this.activateRutClienteComiteHelper = rutValidate(val.rutClienteComite) ? false : true;
    });
  }

  // Valida el tipo de dato si es correcto segun los formatos establecidos, si lo es devuelve el valor sino devuelve nulo

  validaFormatoElemento(value: any, key: string, elementoHTML: any, indexHTML: string): number | string | null {
    let formatos: any = {}
    if(indexHTML !== 'linea-'){
      formatos = this.formatos;
    } else {
      formatos = this.formatosLinea;
    }
    if(formatos[key]){
      if (formatos[key] === 'decimal') {
        if(typeof(value) === 'string'){
          if(!value.includes(',') && !value.includes('.')){ // valores enteros incluye el ,0 al final
            let element: any = parseFloat(value);
            element = element.toFixed(1); // lo deja como string para numeros como 2 -> '2.0' y no 2.0
            if(!(typeof(element) === 'number') && isNaN(element)){
              if(elementoHTML){
                elementoHTML.className = elementoHTML.className + " error-input";
                elementoHTML.title = 'Error de Formato - Debe ser un número entero o decimal';
              }
              return null;
            } else {
              element = element.toString().replace('.', ',');
              return element;
            }
          } else {
            if(!value.includes('.')){ // valores con formato x,xx
              let element: any = parseFloat(value.replace(',', '.'));              
              if(!(this.utilsService.isFloat(element))){
                if (typeof(element) === 'number'){
                  element = element.toFixed(1);
                  element = element.toString().replace('.', ',');
                  return element;
                } else {
                  if(elementoHTML){
                    elementoHTML.className = elementoHTML.className + " error-input";
                    elementoHTML.title = 'Error de Formato - Debe ser un número entero o decimal';
                  }
                  return null;
                }
              } else {
                element = element.toString().replace('.', ',');
                return element;
              }
            } else { // valores con formato x.xx
              let element: any = parseFloat(value);
              if(isNaN(element)){
                if(elementoHTML){
                  elementoHTML.className = elementoHTML.className + " error-input";
                  elementoHTML.title = 'Error de Formato - Debe ser un número entero o decimal';
                }
                return null;
              } else {
                element = value.toString().replace('.', ',');
                return element;
              }
            }
          }
        } 

        if(value === null) {
          if(elementoHTML){
            elementoHTML.className = elementoHTML.className + " error-input";
            elementoHTML.title = 'Error de Formato - Debe ser un número entero o decimal';
          }
        }
      }
      if(formatos[key] === 'si-no'){
        const element = String(value).toUpperCase().trim();
        if(!(element === 'SI' || element === 'NO')){
          if(elementoHTML){
            elementoHTML.className = elementoHTML.className + " error-input";
            elementoHTML.title = 'Error de Formato - Debe ser un valor Si o No';
          }
          return null;
        } else {
          return element;
        }
      }
      if (formatos[key] === 'numero') {
        if(value !== null){
          if(typeof(value) === 'string'){
            let element: any = parseInt(value);
            element = Math.round(element);
            if(!(typeof(element) === 'number') && isNaN(element)){
              if(elementoHTML){
                elementoHTML.className = elementoHTML.className + " error-input";
                elementoHTML.title = 'Error de Formato - Debe ser un número entero';
              }
              return null;
            } else {
              return element;
            }
          } else if (typeof(value) === 'number'){
            const element = Math.round(value);
            if(!(typeof(element) === 'number')){
              if(elementoHTML){
                elementoHTML.className = elementoHTML.className + " error-input";
                elementoHTML.title = 'Error de Formato - Debe ser un número entero';
              }
              return null;
            } else {
              return element;
            }
          } else {
            if(elementoHTML){
              elementoHTML.className = elementoHTML.className + " error-input";
              elementoHTML.title = 'Error de Formato - Debe ser un número entero';
            }
            return null;
          }
        } else {
          if(elementoHTML){
            elementoHTML.className = elementoHTML.className + " error-input";
            elementoHTML.title = 'Error de Formato - Debe ser un número entero';
          }
          return null;
        }
      }
      if(formatos[key] === 'text' && (value === '' || value === null)){
        if(elementoHTML){
          elementoHTML.className = elementoHTML.className + " error-input";
          elementoHTML.title = 'Error de Formato - No debe ser un valor vacio';
        }
        return null;
      }
    }
    return value;
  }

  // Valida objeto de entrada y si tiene un error en un campo lo marca en la vista

  validaObjeto(obj: any, idElement: string, index: number, htmlKey: string = ''): boolean {
    if (typeof(obj) === 'object' && !Array.isArray(obj)) {
      let hasData = false;
      let hasEmptyData = false;
      let hasFormatDataError = false;
      const arrayInputsVacios: string[] = [];
      for(const key in obj) {
        if (obj[key] !== null && typeof(obj[key]) === 'object' && !Array.isArray(obj[key])) {
          if(!this.validaObjeto(obj[key], idElement, index, key)){
            hasFormatDataError = true;
            hasData = true;
          }
        } else {
          const elementoHTML = document.getElementById(idElement + htmlKey + key + index);
          if(elementoHTML){
            elementoHTML.className = elementoHTML.className.replace(" error-input", "");
            elementoHTML.title = '';
          }
          if(String(obj[key]) === "" && elementoHTML !== null) { // Dato vacio
            hasEmptyData = true;
            if(elementoHTML){
              elementoHTML.className = elementoHTML.className + " error-input";
              elementoHTML.title = 'Error de Formato - No debe ser un valor vacio';
            }
          }
          if(String(obj[key]) !== "") { // Dato no vacio
            hasData = true;
            const formato = this.validaFormatoElemento(obj[key], htmlKey + key, elementoHTML, idElement) // Validacion de formato
            if(formato === null){ // Si hay un error de formato lo marca en la vista
              hasFormatDataError = true;
            } else { // Si no hay error se quita la posible marca en la vista
              obj[key] = formato;
              if(elementoHTML){
                elementoHTML.className = elementoHTML.className.replace(" error-input", "");
                elementoHTML.title = '';
              }
            }
          }
        }
      }
      if(hasEmptyData && hasData){ // Faltan datos por llenar
        arrayInputsVacios.forEach((key: string) => {
          const elementoHTML = document.getElementById(idElement + htmlKey + key + index);
          if(elementoHTML){
            elementoHTML.className = elementoHTML.className + " error-input";
            elementoHTML.title = 'Error de Formato - Completar dato';
          }
        });
        return false
      }
      if(hasData && hasFormatDataError){ // Tiene un error de formato del dato ingresado
        return false
      }
      return true;
    } else {
      return false;
    }
  }

  // Valida el objeto de la ficha dependiendo del tipo de dato

  validaObjetoFicha(obj: any, idElement: string): boolean {
    if (typeof(obj) === 'object' && Array.isArray(obj)){
      let valido = true;
      obj.forEach((element: any, index: number) => {
        if(!this.validaObjeto(element, idElement, index)){
          valido = false;
        }
      });
      return valido;
    } else if (typeof(obj) === 'object' && !Array.isArray(obj)) {
      return this.validaObjeto(obj, idElement, 0);
    } else {
      return false;
    }
  }

  // Funcion que valida el llenado de los datos y guarda los datos de la ficha

  guardarFicha(): void{

    if (!this.servicioFichaForm.valid) { // Valida que la cabecera inicial tenga todos los datos
      this.solicitudCreditoService.validateAllFormFields(this.servicioFichaForm);
      this.alertService.error('Solicitud de Crédito - Debe completar los datos necesarios para guardar correctamente.');
      return;
    }
    
    // Valida los datos de las tablas con datos de ingreso manual
    if(!this.validaObjetoFicha(this.sociosComposicion, 'socio-') || !this.validaObjetoFicha(this.empresasRelacionadasComposicion, 'empresa-')
      || !this.validaObjetoFicha(this.deudores, 'deudor-') || 
      !this.validaObjetoFicha(this.lineaOperacionPropuesta, 'linea-') || !this.validaObjetoFicha(this.lineaOperacionPropuestaTotales, 'linea-')
    ){
      this.alertService.error('Solicitud de Crédito - Debe completar correctamente los datos en las filas de las tablas con información ingresada.');
      return;
    }

    
    const elementoHTML = document.getElementById('carga-nombreClienteCargaFinanciera');
    if(elementoHTML){
      elementoHTML.className = elementoHTML.className.replace(" error-input", "");
      elementoHTML.title = '';
    }

    if(!this.validaObjetoFicha(this.cargaFinanciera, 'carga-')){
      this.alertService.error('Solicitud de Crédito - Debe completar correctamente los datos en las filas de las tablas con información ingresada.');
      return;
    } else if (this.validaObjetoFicha(this.cargaFinanciera, 'carga-') && this.nombreClienteCargaFinanciera === '') {
      this.alertService.error('Solicitud de Crédito - Debe completar correctamente el nombre del cliente en la tabla de Carga Financiera.');
      if(elementoHTML){
        elementoHTML.className = elementoHTML.className + " error-input";
        elementoHTML.title = 'Completar dato';
      }
      return;
    }

    if(this.rut === ''){
      this.alertService.error('Solicitud de Crédito - Ocurrio un error al recuperar el rut.');
      return;
    }

    const ficha: any = {
      ficha: {
        servicioFichaForm: this.servicioFichaForm.getRawValue(), // se valida con archivo service
        servicioDeudoresForm: this.servicioDeudoresForm.getRawValue(), // se valida con archivo service
        sociosComposicion: this.sociosComposicion,
        empresasRelacionadasComposicion: this.empresasRelacionadasComposicion,
        sociosInformes: this.sociosInformes, // no se debe validar porque no se modifica
        empresasRelacionadasInformes: this.empresasRelacionadasInformes, // no se debe validar porque no se modifica
        deudores: this.deudores, // validar -> agregar a validacion cuando sea validado
        informacionFinancieraCabecera: this.informacionFinancieraCabecera, // no se debe validar porque no se modifica
        totalesInformacionFinanciera: this.totalesInformacionFinanciera, // no se debe validar porque no se modifica
        informacionFinancieraTable: this.informacionFinancieraTable, // no se debe validar porque no se modifica
        dataFiltrada: this.dataFiltrada, // no se debe validar porque no se modifica
        observaciones: this.observaciones,
        totalesCargaFinanciera: this.totalesCargaFinanciera,
        cargaFinanciera: this.cargaFinanciera,
        tablasCompraVenta: this.tablasCompraVenta,
        nombreClienteCargaFinanciera: this.nombreClienteCargaFinanciera,
        lineaOperacionPropuesta: this.lineaOperacionPropuesta,
        lineaOperacionPropuestaTotales: this.lineaOperacionPropuestaTotales,
        factoring: this.factoring,
        balanceManual: this.balanceManual,
        rut: this.rut,
        consolidadoTitular: this.consolidadoTitular,
        top10Clientes: this.top10Clientes,
        fechasCompraVenta: this.fechasCompraVenta,
        ventaPromMensual: this.ventaPromMensual,
      }
    }

    this.spinner.show();
    this.subscriptions.push(this.solicitudCreditoService.guardarFichaDeCredito(this.rut, this.idTransaccion, ficha).subscribe(resp => {
      this.fichaGuardada = ficha;
      this.alertService.success(resp.message)
      this.spinner.hide();
    }, (error: any) => {
      this.alertService.error(error?.error?.message || 'Solicitud de Crédito - Ocurrio un error con el servicio de guardado de la ficha');
      this.spinner.hide();
    }));
  }

  // Boton Continuar Primera etapa

  avanzarFlujo(): void{
    this.spinner.show();
    this.subscriptions.push(this.solicitudCreditoService.obtenerFlujo(this.idTransaccion, this.rut).subscribe(resp => {
      this.bodyModelos = resp;
      if(this.bodyModelos?.stages[8]?.optional === false){
        if(this.bodyModelos?.stages[8]?.completed){

          this.subscriptions.push(this.solicitudCreditoService.calcularScore(this.idTransaccion, this.rut).subscribe(resp => {
            if(resp?.MotorDeCalculos?.errors?.hassError === false){
              if(resp?.DatosBasicosSolicitud?.Automatico === true){

                this.bloqueaPasos6.emit(true);
                this.solicitudCreditoService.setStep(6);
                this.spinner.hide();

              } else {
                
                this.solicitudCreditoService.setStep('next');
                // bloquea pasos 5
                if(!this.validaUsuarioAdmin()){
                  this.bloqueaPasos5.emit(true);
                }
                this.spinner.hide();
              }
            } else {
              this.alertService.error(resp?.MotorDeCalculos?.details?.message || 'Solicitud de Crédito - Ocurrio un error al recuperar los datos del motor de calculos');
              this.spinner.hide();
            }
          }, (error: any) => {
            this.alertService.error(error?.error?.message || 'Solicitud de Crédito - Ocurrio un error al consultar servicio del motor de calculos');
            this.spinner.hide();
          }));

        } else {
          this.spinner.hide();
          this.alertService.error('Solicitud de Crédito - Debe completar la etapa actual para poder avanzar');
        }
      } else {
        this.solicitudCreditoService.setStep('next');
        this.spinner.hide();
      }
    }, (error: any) => {
      this.alertService.error(error?.error?.message || 'Solicitud de Crédito - Ocurrio un error al recuperar los datos del flujo de credito');
      this.spinner.hide();
    }));
  }

  // Funciones para navegacion

  mapeoSbif(): void {
    const itemSbif: any[] = this.utilsService.mapeoGeneralSbif(this.reportesSeleccionado);
    if(itemSbif && itemSbif.length > 0) {
      this.reportesSeleccionado.deudaSbif.reporte = {
        Documentos: {
          SbifOnline: {
            Reporte: {
              rowsMeses: {
                item: itemSbif
              }
            }
          }
        }
      }
    }
  }

  // Mapea datos para abrir el modal

  mapeoPoderJudicial(): void{
    if(this.reportesSeleccionado?.poderJudicial && Object.keys(this.reportesSeleccionado?.poderJudicial).length > 0){
      this.reportesSeleccionado.poderJudicial = this.utilsService.mapeoPoderJudicial(this.reportesSeleccionado?.poderJudicial);
    }
  }

  mapeoVehiculos(): void{
    if(this.reportesSeleccionado?.vehiculos?.reporte){
      this.reportesSeleccionado.objReporteVehiculos = this.reportesSeleccionado?.vehiculos?.reporte;
    }
  }

  mapeoBienesRaices(): void{
    if(this.reportesSeleccionado?.bienesRaices?.reporte){
      this.reportesSeleccionado.objReporteBienesRaices = this.reportesSeleccionado?.bienesRaices?.reporte;
    }
  }

  // Valida los objetos para abrir el modal

  validaObjetos(): void{
    if(this.reportesSeleccionado?.cteVentasBalancesRentas?.reporte && Object.keys(this.reportesSeleccionado?.cteVentasBalancesRentas?.reporte).length === 0){
      this.reportesSeleccionado.cteVentasBalancesRentas.reporte = null;
    }
    if(this.reportesSeleccionado?.basicReport?.reporte && Object.keys(this.reportesSeleccionado?.basicReport?.reporte).length === 0){
      this.reportesSeleccionado.basicReport.reporte = null;
    }
    if(this.reportesSeleccionado?.deudaSbif?.reporte && Object.keys(this.reportesSeleccionado?.deudaSbif?.reporte).length === 0){
      this.reportesSeleccionado.deudaSbif.reporte = null;
    }
    if(this.reportesSeleccionado?.boletinConcursal?.reporte && Object.keys(this.reportesSeleccionado?.boletinConcursal?.reporte).length === 0){
      this.reportesSeleccionado.boletinConcursal.reporte = null;
    }
    if(this.reportesSeleccionado?.reporteEmpresaDia?.reporte && Object.keys(this.reportesSeleccionado?.reporteEmpresaDia?.reporte).length === 0){
      this.reportesSeleccionado.reporteEmpresaDia.reporte = null;
    }
  }

  // Funcion para abrir modal con datos basicos en tabla de informes comerciales

  abrirModal(entidad: string, rut: string): void{
    if(rut && entidad){
      if(this.reportesDerivadosObj[entidad]?.[rut]){
        this.reportesSeleccionado = this.reportesDerivadosObj[entidad][rut];
        this.rutSeleccionado = rut;
        this.informeComercial = this.utilsService.identificarInformeComercial(this.reportesSeleccionado?.basicReport?.reporte);
        this.mapeoPoderJudicial();
        this.mapeoVehiculos();
        this.mapeoBienesRaices();
        this.mapeoSbif();
        this.validaObjetos();
        this.plantillaAntecedentes = '';
        this.modalDefault = true;
  
        this.modalService.open();
      }
    }
    
  }

  abrirModalTitular(): void{
    if(this.reportesPrincipalesObj){
      this.mapeoReporteTitular();
      this.mapeoPoderJudicial();
      this.mapeoSbif();
      this.validaObjetos();
    }

    this.reportesSeleccionado.consolidadoTitular = this.consolidadoTitular;
  
    this.rutSeleccionado = this.rut;
    this.plantillaAntecedentes = 'cesceDemo';
    this.modalDefault = false;

    this.modalService.open();
  }

  mapeoReporteTitular(): void {
    this.reportesSeleccionado = {
      deudaSbif: this.reportesPrincipalesObj?.deudaSbif,
      poderJudicial: this.reportesPrincipalesObj?.poderJudicial,
      boletinConcursal: this.reportesPrincipalesObj?.boletinConcursal,
      objReporteVehiculos: this.reportesPrincipalesObj?.vehiculos?.reporte,
      objReporteBienesRaices: this.reportesPrincipalesObj?.bienesRaices?.reporte
    } 

  }

  // Scrollea automaticamente la vista a la seccion seleccionada

  scroll(el: string, event: any) {
    let button = event.target as HTMLElement | null;
    const elementHTML = document.getElementById(el) as HTMLElement | null;
    if(button?.classList.contains('fa')){
      button = button?.parentElement as HTMLElement | null;
    }
    elementHTML?.classList.toggle('container-desplegables');
    if ( !elementHTML?.classList.contains('container-desplegables') ){
      elementHTML?.scrollIntoView(true);
      button?.classList.add('button-selected');
      button?.classList.remove('border');
      button?.classList.remove('border-buttons');
      button?.classList.add('border-0'); 

    } else {
      button?.classList.remove('button-selected');
      button?.classList.add('border');
      button?.classList.add('border-buttons');
      button?.classList.remove('border-0'); 
    }
  }

  // Muestra u oculta seccion dependiendo de seleccion del usuario

  show(el: string, buttonId?: string) {
    const elementHTML = document.getElementById(el) as HTMLElement;
    elementHTML.classList.toggle('container-desplegables');
    if(buttonId){
      const button = document.getElementById(buttonId) as HTMLElement;
      if ( !elementHTML.classList.contains('container-desplegables') ){
        button.classList.add('button-selected');
        button.classList.remove('border');
        button.classList.remove('border-buttons');
        button.classList.add('border-0'); 
      } else {
        button.classList.remove('button-selected');
        button.classList.add('border');
        button.classList.add('border-buttons');
        button.classList.remove('border-0'); 
      }
    }
  }

  // Agrega Fila en Carga financiera

  addRowCargaFinanciera(): void{
    if(this.cargaFinanciera.length < 10){
      this.cargaFinanciera.push(
        {
          fechaCurse: '',
          institucion: '',
          tipoCredito: '',
          creditoOriginal: '',
          deudaActual: '',
          cuota: '',
          nCuotasPorPagar: '',
          nCuotasMorosas: '',
          ultimoVencimiento: '',
          garantiasVigentes: ''
        }
      )
    }
  }

  // Elimina Fila en Carga financiera

  deleteRowCargaFinanciera(index: number): void{
    if(this.cargaFinanciera.length > 0){
      this.cargaFinanciera.splice(index, 1);
    }
  }

  // Calculos Totales Tabla Carga Financiera

  calcularTotalCreditoOriginal(): number {
    let suma = 0;
    this.cargaFinanciera.forEach((element: any) => {
      if(typeof(element.creditoOriginal)==='number')
        suma += element.creditoOriginal;
    })
    this.totalesCargaFinanciera.creditoOriginal = suma;
    return suma
  }

  calcularTotalDeudaActual(): number {
    let suma = 0;
    this.cargaFinanciera.forEach((element: any) => {
      if(typeof(element.deudaActual)==='number')
        suma += element.deudaActual;
    })
    this.totalesCargaFinanciera.deudaActual = suma;
    return suma
  }

  calcularTotalCuota(): number {
    let suma = 0;
    this.cargaFinanciera.forEach((element: any) => {
      if(typeof(element.cuota)==='number')
        suma += element.cuota;
    })
    this.totalesCargaFinanciera.cuota = suma;
    return suma
  }

  calcularTotalNCuotasPorPagar(): number {
    let suma = 0;
    this.cargaFinanciera.forEach((element: any) => {
      if(typeof(element.nCuotasPorPagar)==='number')
        suma += element.nCuotasPorPagar;
    })
    this.totalesCargaFinanciera.nCuotasPorPagar = suma;
    return suma
  }

  calcularTotalNCuotasMorosas(): number {
    let suma = 0;
    this.cargaFinanciera.forEach((element: any) => {
      if(typeof(element.nCuotasMorosas)==='number')
        suma += element.nCuotasMorosas;
    })
    this.totalesCargaFinanciera.nCuotasMorosas = suma;
    return suma
  }


  // Calculos Totales Tabla Línea / Operación Propuesta

  calcularTotalLineaVigente(): void {
    let suma = 0;

    typeof(this.lineaOperacionPropuesta.lineaVigente.facturas)==='number' ? suma += this.lineaOperacionPropuesta.lineaVigente.facturas : null;
    typeof(this.lineaOperacionPropuesta.lineaVigente.fache)==='number' ? suma += this.lineaOperacionPropuesta.lineaVigente.fache : null;
    typeof(this.lineaOperacionPropuesta.lineaVigente.cheques)==='number' ? suma += this.lineaOperacionPropuesta.lineaVigente.cheques : null;
    typeof(this.lineaOperacionPropuesta.lineaVigente.confirming)==='number' ? suma += this.lineaOperacionPropuesta.lineaVigente.confirming : null;
    typeof(this.lineaOperacionPropuesta.lineaVigente.oc)==='number' ? suma += this.lineaOperacionPropuesta.lineaVigente.oc : null;
    typeof(this.lineaOperacionPropuesta.lineaVigente.creditoDirecto)==='number' ? suma += this.lineaOperacionPropuesta.lineaVigente.creditoDirecto : null;
    typeof(this.lineaOperacionPropuesta.lineaVigente.prontoPago)==='number' ? suma += this.lineaOperacionPropuesta.lineaVigente.prontoPago : null;

    this.lineaOperacionPropuestaTotales.totalesLineaVigente = suma;

    this.limpiaFecha();
    this.calcularTotalLineaM();
  }

  calcularTotalLineaPropuesta(): void {
    let suma = 0;

    typeof(this.lineaOperacionPropuesta.lineaPropuesta.facturas)==='number' ? suma += this.lineaOperacionPropuesta.lineaPropuesta.facturas : null;
    typeof(this.lineaOperacionPropuesta.lineaPropuesta.fache)==='number' ? suma += this.lineaOperacionPropuesta.lineaPropuesta.fache : null;
    typeof(this.lineaOperacionPropuesta.lineaPropuesta.cheques)==='number' ? suma += this.lineaOperacionPropuesta.lineaPropuesta.cheques : null;
    typeof(this.lineaOperacionPropuesta.lineaPropuesta.confirming)==='number' ? suma += this.lineaOperacionPropuesta.lineaPropuesta.confirming : null;
    typeof(this.lineaOperacionPropuesta.lineaPropuesta.oc)==='number' ? suma += this.lineaOperacionPropuesta.lineaPropuesta.oc : null;
    typeof(this.lineaOperacionPropuesta.lineaPropuesta.creditoDirecto)==='number' ? suma += this.lineaOperacionPropuesta.lineaPropuesta.creditoDirecto : null;
    typeof(this.lineaOperacionPropuesta.lineaPropuesta.prontoPago)==='number' ? suma += this.lineaOperacionPropuesta.lineaPropuesta.prontoPago : null;

    this.lineaOperacionPropuestaTotales.totalesLineaPropuesta = suma;

    this.limpiaFecha();
    this.calcularTotalLineaM();
  }

  calcularTotalOpPuntualVigente(): void {
    let suma = 0;

    typeof(this.lineaOperacionPropuesta.opPuntualVigente.facturas)==='number' ? suma += this.lineaOperacionPropuesta.opPuntualVigente.facturas : null;
    typeof(this.lineaOperacionPropuesta.opPuntualVigente.fache)==='number' ? suma += this.lineaOperacionPropuesta.opPuntualVigente.fache : null;
    typeof(this.lineaOperacionPropuesta.opPuntualVigente.cheques)==='number' ? suma += this.lineaOperacionPropuesta.opPuntualVigente.cheques : null;
    typeof(this.lineaOperacionPropuesta.opPuntualVigente.confirming)==='number' ? suma += this.lineaOperacionPropuesta.opPuntualVigente.confirming : null;
    typeof(this.lineaOperacionPropuesta.opPuntualVigente.oc)==='number' ? suma += this.lineaOperacionPropuesta.opPuntualVigente.oc : null;
    typeof(this.lineaOperacionPropuesta.opPuntualVigente.creditoDirecto)==='number' ? suma += this.lineaOperacionPropuesta.opPuntualVigente.creditoDirecto : null;
    typeof(this.lineaOperacionPropuesta.opPuntualVigente.prontoPago)==='number' ? suma += this.lineaOperacionPropuesta.opPuntualVigente.prontoPago : null;

    this.lineaOperacionPropuestaTotales.totalesOpPuntualVigente = suma;

    this.limpiaFecha();
    this.calcularOpPuntualM()
  }

  calcularTotalOpPuntualPropuesta(): void {
    let suma = 0;

    typeof(this.lineaOperacionPropuesta.opPuntualPropuesta.facturas)==='number' ? suma += this.lineaOperacionPropuesta.opPuntualPropuesta.facturas : null;
    typeof(this.lineaOperacionPropuesta.opPuntualPropuesta.fache)==='number' ? suma += this.lineaOperacionPropuesta.opPuntualPropuesta.fache : null;
    typeof(this.lineaOperacionPropuesta.opPuntualPropuesta.cheques)==='number' ? suma += this.lineaOperacionPropuesta.opPuntualPropuesta.cheques : null;
    typeof(this.lineaOperacionPropuesta.opPuntualPropuesta.confirming)==='number' ? suma += this.lineaOperacionPropuesta.opPuntualPropuesta.confirming : null;
    typeof(this.lineaOperacionPropuesta.opPuntualPropuesta.oc)==='number' ? suma += this.lineaOperacionPropuesta.opPuntualPropuesta.oc : null;
    typeof(this.lineaOperacionPropuesta.opPuntualPropuesta.creditoDirecto)==='number' ? suma += this.lineaOperacionPropuesta.opPuntualPropuesta.creditoDirecto : null;
    typeof(this.lineaOperacionPropuesta.opPuntualPropuesta.prontoPago)==='number' ? suma += this.lineaOperacionPropuesta.opPuntualPropuesta.prontoPago : null;

    this.lineaOperacionPropuestaTotales.totalesOpPuntualPropuesta = suma;
    
    this.limpiaFecha();
    this.calcularOpPuntualM();
  }

  calcularTotalVigente(): void {
    let suma = 0;

    typeof(this.lineaOperacionPropuesta.vigente.facturas)==='number' ? suma += this.lineaOperacionPropuesta.vigente.facturas : null;
    typeof(this.lineaOperacionPropuesta.vigente.fache)==='number' ? suma += this.lineaOperacionPropuesta.vigente.fache : null;
    typeof(this.lineaOperacionPropuesta.vigente.cheques)==='number' ? suma += this.lineaOperacionPropuesta.vigente.cheques : null;
    typeof(this.lineaOperacionPropuesta.vigente.confirming)==='number' ? suma += this.lineaOperacionPropuesta.vigente.confirming : null;
    typeof(this.lineaOperacionPropuesta.vigente.oc)==='number' ? suma += this.lineaOperacionPropuesta.vigente.oc : null;
    typeof(this.lineaOperacionPropuesta.vigente.creditoDirecto)==='number' ? suma += this.lineaOperacionPropuesta.vigente.creditoDirecto : null;
    typeof(this.lineaOperacionPropuesta.vigente.prontoPago)==='number' ? suma += this.lineaOperacionPropuesta.vigente.prontoPago : null;

    this.lineaOperacionPropuestaTotales.totalesVigente = suma;
    this.limpiaFecha();
  }

  calcularTotalPropuesta(): void {
    let suma = 0;

    typeof(this.lineaOperacionPropuesta.propuesta.facturas)==='number' ? suma += this.lineaOperacionPropuesta.propuesta.facturas : null;
    typeof(this.lineaOperacionPropuesta.propuesta.fache)==='number' ? suma += this.lineaOperacionPropuesta.propuesta.fache : null;
    typeof(this.lineaOperacionPropuesta.propuesta.cheques)==='number' ? suma += this.lineaOperacionPropuesta.propuesta.cheques : null;
    typeof(this.lineaOperacionPropuesta.propuesta.confirming)==='number' ? suma += this.lineaOperacionPropuesta.propuesta.confirming : null;
    typeof(this.lineaOperacionPropuesta.propuesta.oc)==='number' ? suma += this.lineaOperacionPropuesta.propuesta.oc : null;
    typeof(this.lineaOperacionPropuesta.propuesta.creditoDirecto)==='number' ? suma += this.lineaOperacionPropuesta.propuesta.creditoDirecto : null;
    typeof(this.lineaOperacionPropuesta.propuesta.prontoPago)==='number' ? suma += this.lineaOperacionPropuesta.propuesta.prontoPago : null;

    this.lineaOperacionPropuestaTotales.totalesPropuesta = suma;
    this.limpiaFecha();
  }

  calcularTotalCancelada(): void {
    let suma = 0;

    typeof(this.lineaOperacionPropuesta.cancelada.facturas)==='number' ? suma += this.lineaOperacionPropuesta.cancelada.facturas : null;
    typeof(this.lineaOperacionPropuesta.cancelada.fache)==='number' ? suma += this.lineaOperacionPropuesta.cancelada.fache : null;
    typeof(this.lineaOperacionPropuesta.cancelada.cheques)==='number' ? suma += this.lineaOperacionPropuesta.cancelada.cheques : null;
    typeof(this.lineaOperacionPropuesta.cancelada.confirming)==='number' ? suma += this.lineaOperacionPropuesta.cancelada.confirming : null;
    typeof(this.lineaOperacionPropuesta.cancelada.oc)==='number' ? suma += this.lineaOperacionPropuesta.cancelada.oc : null;
    typeof(this.lineaOperacionPropuesta.cancelada.creditoDirecto)==='number' ? suma += this.lineaOperacionPropuesta.cancelada.creditoDirecto : null;
    typeof(this.lineaOperacionPropuesta.cancelada.prontoPago)==='number' ? suma += this.lineaOperacionPropuesta.cancelada.prontoPago : null;

    this.lineaOperacionPropuestaTotales.totalesCancelada = suma;
    this.limpiaFecha();
  }

  calcularOpPuntualM(): void {
    let suma = 0;

    suma = Number(this.lineaOperacionPropuestaTotales.totalesOpPuntualVigente) + Number(this.lineaOperacionPropuestaTotales.totalesOpPuntualPropuesta) || 0;
    this.lineaOperacionPropuesta.opPuntualM = suma;

    this.calcularRiesgoTotalM();
  }

  calcularTotalLineaM(): void {
    if(Number(this.lineaOperacionPropuestaTotales.totalesLineaPropuesta)>0){
      this.lineaOperacionPropuesta.totalLineaM = Number(this.lineaOperacionPropuestaTotales.totalesLineaPropuesta);
    } else {
      this.lineaOperacionPropuesta.totalLineaM = Number(this.lineaOperacionPropuestaTotales.totalesLineaVigente) || 0;
    }

    this.calcularRiesgoTotalM();
  }

  calcularRiesgoTotalM(): void {
    let suma = 0;

    suma = Number(this.lineaOperacionPropuesta.opPuntualM) + Number(this.lineaOperacionPropuesta.totalLineaM) || 0;
    this.lineaOperacionPropuesta.riesgoTotalM = suma;
  }

  limpiaFecha(): void {
    if(
      this.lineaOperacionPropuestaTotales.totalesLineaVigente === 0 &&
      this.lineaOperacionPropuestaTotales.totalesLineaPropuesta === 0 &&
      this.lineaOperacionPropuestaTotales.totalesOpPuntualVigente === 0 &&
      this.lineaOperacionPropuestaTotales.totalesOpPuntualPropuesta === 0 &&
      this.lineaOperacionPropuestaTotales.totalesPorcentaje === 0 &&
      this.lineaOperacionPropuestaTotales.totalesPlazoDias === 0 &&
      this.lineaOperacionPropuestaTotales.totalesVigente === 0 &&
      this.lineaOperacionPropuestaTotales.totalesPropuesta === 0 &&
      this.lineaOperacionPropuestaTotales.totalesCancelada === 0
    ){
      this.lineaOperacionPropuesta.vencimiento = '';
    } 
  }

  cambiarFecha12(): void {
    const date = new Date();
    const newDate = new Date(date.setMonth(date.getMonth()+12));

    const day = newDate.getDate();
    const month = newDate.getMonth() + 1;
    const year = newDate.getFullYear();

    if(month < 10){
      this.lineaOperacionPropuesta.vencimiento = `${year}-0${month}-${day}`;
    }else{
      this.lineaOperacionPropuesta.vencimiento `${year}-${month}-${day}`;
    }

    this.limpiaFecha();

  }

  cambiarFecha6(): void {
    const date = new Date();
    const newDate = new Date(date.setMonth(date.getMonth()+6));

    const day = newDate.getDate();
    const month = newDate.getMonth() + 1;
    const year = newDate.getFullYear();

    if(month < 10){
      this.lineaOperacionPropuesta.vencimiento = `${year}-0${month}-${day}`;
    }else{
      this.lineaOperacionPropuesta.vencimiento `${year}-${month}-${day}`;
    }

    this.limpiaFecha();

  }

  handleEvent(eventKey: string[]): void {
    if(eventKey.includes('calcularTotalLineaVigente')) {
      this.calcularTotalLineaVigente();
    }
    if(eventKey.includes('cambiarFecha12')) {
      this.cambiarFecha12();
    }
    if(eventKey.includes('calcularTotalLineaPropuesta')) {
      this.calcularTotalLineaPropuesta();
    }
    if(eventKey.includes('calcularTotalOpPuntualVigente')) {
      this.calcularTotalOpPuntualVigente();
    }
    if(eventKey.includes('calcularTotalOpPuntualPropuesta')) {
      this.calcularTotalOpPuntualPropuesta();
    }
    if(eventKey.includes('calcularTotalVigente')) {
      this.calcularTotalVigente();
    }
    if(eventKey.includes('calcularTotalPropuesta')) {
      this.calcularTotalPropuesta();
    }
    if(eventKey.includes('calcularTotalCancelada')) {
      this.calcularTotalCancelada();
    }
    if(eventKey.includes('cambiarFecha6')) {
      this.cambiarFecha6();
    }
    if(eventKey.includes('calcularTotalLineaM')) {
      this.calcularTotalLineaM();
    }
    if(eventKey.includes('limpiaFecha')) {
      this.limpiaFecha();
    }
    if(eventKey.includes('calcularOpPuntualM')) {
      this.calcularOpPuntualM();
    }
  }

  stringToFloat(number: any): number {
    return parseFloat(number.toString().replace(',', '.')) || 0;
  }

  finalizar(): void {
    this.finalizarFlujo.emit();
  }

  setToday(): void {
    this.today = `${new Date().getFullYear()}${(new Date().getMonth() + 1 < 10?  '0'+(new Date().getMonth() + 1) : 
      new Date().getMonth() + 1)}${new Date().getDate()}`;        
  }

  agregarSaltosDeLinea(texto: string): string {
    if (!texto || texto == '') return texto;
    return texto.replace(new RegExp('\n', 'g'), '<br />');
  }

  validaUsuarioAdmin(): boolean {
    return this._sessionService.getUserAccess().includes(this.access[3]);
  }

  volverEtapaPrevia(): void {
    this.bloqueaPasos5.emit(false);
    this.solicitudCreditoService.setStep(Number(this.stepper - 1));
    this.spinner.hide();
  }

  dividirValor(numero: number | string, divisor: number): string {
    if (numero === undefined || numero === null) {
      return "";
    }
    const valorNumerico = Number(numero);
    if (isNaN(valorNumerico)) {
      return "";
    }
    const valorDividido = valorNumerico / divisor;
    return valorDividido.toString();
  }

  // Boton continuar etapa final

  continuar(): void{
    this.spinner.show();
    this.subscriptions.push(this.solicitudCreditoService.obtenerFlujo(this.idTransaccion, this.rut).subscribe(resp => {
      this.bodyModelos = resp;
      if(this.bodyModelos?.stages[9]?.optional === false){
        if(this.bodyModelos?.stages[9]?.completed){
          
          // Llamada a servicio para inciar aprobacion
          this.subscriptions.push(this.solicitudCreditoService.iniciarFlujoAprobacional(this.idTransaccion, this.rut).subscribe(resp => {
            const error = resp?.ServicioAprobacional?.errors || null;
            if(error?.hassError === true){
              this.alertService.error(error?.details?.message || 'Solicitud de Crédito - Ocurrio un error al actualizar el flujo');
              this.spinner.hide();
            } else {
              this.solicitudCreditoService.setStep('next');
              this.bloqueaPasos6.emit(true);
              this.spinner.hide();
            }
          }, (error: any) => {
            this.alertService.error(error?.error?.message || 'Solicitud de Crédito - Ocurrio un error al consultar con el servicio para iniciar el flujo aprobacional');
            this.spinner.hide();
          }));

        } else {
          this.spinner.hide();
          this.alertService.error('Solicitud de Crédito - Debe completar la etapa actual para poder avanzar');
        }
      } else {
        // Llamada a servicio para inciar aprobacion
        this.subscriptions.push(this.solicitudCreditoService.iniciarFlujoAprobacional(this.idTransaccion, this.rut).subscribe(resp => {
          const error = resp?.ServicioAprobacional?.errors || null;
          if(error?.hassError === true){
            this.alertService.error(error?.details?.message || 'Solicitud de Crédito - Ocurrio un error al actualizar el flujo');
            this.spinner.hide();
          } else {
            this.solicitudCreditoService.setStep('next');
            this.bloqueaPasos6.emit(true);
            this.spinner.hide();
          }
        }, (error: any) => {
          this.alertService.error(error?.error?.message || 'Solicitud de Crédito - Ocurrio un error al consultar con el servicio para iniciar el flujo aprobacional');
          this.spinner.hide();
        }));
      }
    }, (error: any) => {
      this.alertService.error(error?.error?.message || 'Solicitud de Crédito - Ocurrio un error al recuperar los datos del flujo de credito');
      this.spinner.hide();
    }));
  }

  validaArraySF(): boolean {
    if(this.sociosComposicion && this.sociosComposicion.length > 0){
      const fs = this.sociosComposicion.find(e => e.fs === 'SI');
      if(fs){
        if(!(this.stepper === 4 && this.plantillaNoEditable === false) && !this.sociosComposicion.find(e => e.direccion)) {
          return false;
        }
        return true;
      }
    }
    return false;
  }

  validaSFElement(index: number): void {
    if(index >= 0 && this.sociosComposicion[index] && Object.keys(this.sociosComposicion[index]).length > 0){
      if(this.sociosComposicion[index].fs === 'SI') {
        this.sociosComposicion[index].direccion = '';
      } else {
        delete this.sociosComposicion[index].direccion;
      }
    }
  }

}
